import React from "react";
import { RecommendedProductsBlockProps } from "../../types/search";
import { ProductHit } from "../../types/searchResults";
import { ProductResult, isProductResult } from "../../search-core/types/ProductResult";
import ProductCard from "../search-results/ProductCard";
import { addToCart } from "../../services/cart/cartActions";
import "../../styles.css";
import { DEFAULT_RECOMMENDATION_CONFIG } from "../../search-core/recommendations";

/**
 * RecommendedProductsBlock - Displays a grid of recommended product cards
 *
 * This component shows a list of recommended products in a grid layout.
 * No functionality except optional click handlers for future use.
 */
const RecommendedProductsBlock: React.FC<RecommendedProductsBlockProps> = ({
  products,
  onProductActionClick,
}) => {
  const handleAddToCart = (product: ProductHit | ProductResult) => {
    // If parent provided a custom handler, use it (backward compatibility)
    if (onProductActionClick) {
      // Ensure product.id exists before calling
      if (product.id !== undefined) {
        onProductActionClick(product.id);
      } else {
        console.warn("Product ID is undefined, cannot call onProductActionClick");
      }
      return;
    }

    // Use unified cart action handler (works with both types)
    addToCart(product);
  };

  // Filter only ProductResult items (skip legacy RecommendedProduct)
  const productResults = products.filter(isProductResult);

  return (
    <div className="recommended-products-block">
      <div className="block-header">
        <h3 className="block-title">Рекомендуем для вас</h3>
      </div>

      {productResults.length > 0 ? (
        <div className="products-flex">
          {productResults.slice(0, DEFAULT_RECOMMENDATION_CONFIG.maxSeedQueries).map((product) => (
            <ProductCard key={product.id} product={product} onActionClick={handleAddToCart} />
          ))}
        </div>
      ) : (
        <p className="empty-message">Нет рекомендуемых товаров</p>
      )}
    </div>
  );
};

export default RecommendedProductsBlock;
